import { useMemo } from 'react'
import { Award, ShieldCheck, AlertCircle } from 'lucide-react'
import { cmsStatusLabel, cmsStatusTone, mapScoreToCmsStatus } from '../../lib/services/scoringPresentation'

interface ScoringGradeProps {
    compliantCount: number
    totalCount: number
}

/**
 * CMS status presentation for visit checklist readiness.
 */
export function ScoringSection({ compliantCount, totalCount }: ScoringGradeProps) {
    const percentage = totalCount > 0 ? (compliantCount / totalCount) * 100 : 0

    const status = useMemo(() => {
        const statusCode = mapScoreToCmsStatus(percentage)
        const tone = cmsStatusTone(statusCode)
        return { statusCode, tone, label: cmsStatusLabel(statusCode) }
    }, [percentage])

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div className="app-surface flex items-center gap-4 p-4">
        <div className={`flex h-16 items-center justify-center rounded-full px-4 text-xs font-black uppercase tracking-wide ${status.tone.bg} ${status.tone.text}`}>
          {status.label}
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-tight text-neutral-500">CMS Readiness Status</p>
          <p className="text-lg font-bold text-neutral-900">Status-driven compliance framing</p>
        </div>
      </div>

      <div className="rounded-xl bg-[linear-gradient(135deg,_#173f6b,_#0f5f89)] p-4 text-white shadow-sm">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-xs font-bold uppercase text-blue-100">Findings Status</p>
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-1">
                <ShieldCheck size={16} className="text-emerald-300" />
                <span className="text-sm font-bold">{compliantCount} Compliant</span>
              </span>
              <span className="flex items-center gap-1">
                <AlertCircle size={16} className="text-rose-300" />
                <span className="text-sm font-bold">{totalCount - compliantCount} Flags</span>
              </span>
            </div>
          </div>
          <Award size={32} className="text-amber-300/80" />
        </div>
      </div>
    </div>
  )
}
